import { WorkHours } from "./types";

export const MAX_DATE_RANGE = 60; // e.g., 2 weeks (14 days)
export const MAX_WORK_HOURS_UPDATE_RANGE_DAYS = 180;
export const TIME_INTERVAL = 5; // Time interval in minutes (could be 1, 15, 30, etc.) THIS SHOULD NEVER CHANGE!!
export const SELECTION_TIME_INTERVAL = 15; // These are the times in which the user can select an appointment!
export const APPOINTMENT_ID_LENGTH = 6;
export const APPOINTMENT_ID_COLLISION_RETRIES = 5;
export const EMPLOYEE_BIO_MAX_LENGTH = 280;

export const BITSTRING_LENGTH = 24 * 60 / TIME_INTERVAL; // 24 hours * 60 minutes / interval

export const BUFFER_PERIOD = 30; //Buffer period in days that we allow people to book

// This is used to key through day js object ('dayJSObject.day()' returns a number corresponding to this.)
export const DAYJS_DAYS_OF_WEEK: (keyof WorkHours)[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const DAYS_OF_WEEK_PREFERRED_ORDER: (keyof WorkHours)[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Asia/Dubai',
  'Australia/Sydney',
];

const generateNineToFiveBitString = () => {
  const slotsPerHour = 60 / TIME_INTERVAL;

  // Total slots for 9 AM - 5 PM
  const startIndex = 9 * slotsPerHour;      // 9:00 AM
  const lunchStartIndex = 12 * slotsPerHour; // 12:00 PM (Lunch Break)
  const lunchEndIndex = 13 * slotsPerHour;   // 1:00 PM
  const endIndex = 17 * slotsPerHour;        // 5:00 PM

  const bitstring = Array(BITSTRING_LENGTH).fill('0'); // Default to unavailable

  // Fill 9 AM - 12 PM slots
  bitstring.fill('1', startIndex, lunchStartIndex);
  // Fill 1 PM - 5 PM slots
  bitstring.fill('1', lunchEndIndex, endIndex);

  return bitstring.join('');
};
export const NINE_TO_FIVE_BITSTRING = generateNineToFiveBitString();

const EMPTY_WORK_HOURS: WorkHours = {
  monday: '',
  tuesday: '',
  wednesday: '',
  thursday: '',
  friday: '',
  saturday: '',
  sunday: '',
};

const HOURS_PATTERN =
  /^((?:0?[1-9]|1[0-2]):[0-5][0-9](?:AM|PM))\s*-\s*((?:0?[1-9]|1[0-2]):[0-5][0-9](?:AM|PM))(?:\s*\(([A-Za-z0-9\s'-]{0,20})\))?$/i;
export const BUSINESS_HOURS_REGEX = HOURS_PATTERN;
export const BUSINESS_HOURS_NOTE_LIMIT = 20;

export const ensureBusinessHoursShape = (hours?: Partial<WorkHours> | null): WorkHours => ({
  ...EMPTY_WORK_HOURS,
  ...(hours ?? {}),
});
